<!--
 * @Description: 合作伙伴详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-06-20 16:27:28
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent
        header
        :title="data?.customerInfo?.customerName || '--'"
        :sellerName="data?.customerInfo?.sellerName"
        :customLabel="t('custom.customerNumber')"
        :customValue="data?.customerInfo?.customerNumber"
      >
        <a-tabs @change="changeTabs" v-model:activeKey="activeKey">
          <a-tab-pane key="base" :tab="t('common.baseTabs')">
            <baseMessage :disabled="true" formItemView :data="data" type="clients" :permissionPage="permissionBasic" />
          </a-tab-pane>
          <a-tab-pane key="contact" :tab="t('common.concatTabs')">
            <TabsContacts
              ref="contactsRef"
              appId="cos_ofbu"
              :contactRefId="route.query.cosId"
              :permissionPage="permissionConcat"
            />
          </a-tab-pane>
          <a-tab-pane key="3" :tab="t('common.followTabs')">
            <TabsClueCosFollowUp
              appId="cos_ofbu"
              :workCode="data.customerInfo.seller"
              :showFooter="true"
              :followRefId="route.query.cosId"
              :permissionPage="permissionFollow"
            />
          </a-tab-pane>
          <a-tab-pane key="4" :tab="t('common.bussiessTabs')">
            <tabsBusiness :workCode="data.customerInfo.seller" :permissionPage="permissionBuss" />
          </a-tab-pane>
          <a-tab-pane key="5" :tab="t('common.contractTabs')">
            <tabsContract />
          </a-tab-pane>
          <a-tab-pane key="6" :tab="t('common.conversionTabs')">
            <TabsConversion :resourceId="route.query.cosId" appId="cos_ofbu" />
          </a-tab-pane>
          <a-tab-pane key="operationLog" :tab="t('common.operationLogTabs')">
            <TabsOperationLog
              ref="operationLogRef"
              tableId="DcCosOFbuClientsOperationLog"
              appId="cos_ofbu"
              :resourceId="route.query.cosId"
            />
          </a-tab-pane>
          <a-tab-pane key="8" :tab="t('common.arkCodeTabs')">
            <tabsCode />
          </a-tab-pane>
          <a-tab-pane key="9" :tab="t('common.subjectTabs')">
            <tabsMainBody />
          </a-tab-pane>
          <a-tab-pane key="10" :tab="t('exception.exceptionSituation')">
            <tabsAlarmList :cosId="route.query.cosId"/>
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
      <ViewFooterBtn
        :permissionPage="permissionBasic"
        @success="footerSuccess"
        :loading="loading"
        type="clients"
        :workCode="data?.customerInfo?.seller"
      />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsConversion from '@/components/TabsConversion'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/overseasSales/customerCenter/components/baseMessage.vue'
import tabsContract from '@/views/overseasSales/customerCenter/components/tabsContract.vue'
import ViewFooterBtn from '@/views/overseasSales/customerCenter/components/viewFooterBtn.vue'
import tabsCode from '@/views/overseasSales/customerCenter/components/tabsCode.vue'
import tabsBusiness from '@/views/overseasSales/customerCenter/components/tabsBusiness.vue'
import tabsMainBody from '@/views/overseasSales/customerCenter/components/tabsMainBody.vue'
import tabsAlarmList from '@/views/overseasSales/customerCenter/components/tabsAlarmList.vue'
import { potentialDetail } from '@/api/overseasSales/customerCenter'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const route = useRoute()
const data = ref({})
const operationLogRef = ref()
const contactsRef = ref()
const activeKey = ref('base')
const loading = ref(false)
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
          res.data.business.businessTypeSelect = res.data.business.businessType[0]
        }
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 标签页切换
const changeTabs = (v: string) => {
  if (v === 'base') {
    fetch()
  } else if (v === 'operationLog') {
    // 更新联系人或者操作日志
    if (activeKey.value === 'contact') {
      contactsRef.value?.refresh()
    } else if (activeKey.value === 'operationLog') {
      operationLogRef.value?.fetch()
    }
  }
}
onMounted(() => {
  fetch()
})
const permissionBasic = {
  transfer: 'ofbu_clients_transfer_btn',
  follow_add: 'ofbu_clients_follow_add_btn',
  visitor_add: 'ofbu_clients_visitor_add_btn',
  edit: 'ofbu_clients_edit_btn',
  buss_add: 'ofbu_clients_buss_add_btn',
  concat_add: 'ofbu_clients_concat_add_btn'
}
const permissionFollow = {
  edit: 'ofbu_clients_follow_edit_btn',
  del: 'ofbu_clients_follow_del_btn',
  comment: 'ofbu_clients_follow_comment_btn'
}
const permissionBuss = {
  edit: 'ofbu_clients_buss_edit_btn',
  del: 'ofbu_clients_buss_del_btn'
}
const permissionConcat = {
  edit: 'ofbu_clients_concat_edit_btn',
  del: 'ofbu_clients_concat_del_btn'
}
const footerSuccess = (tag: 'base' | 'contact') => {
  if (tag === 'base') {
    fetch()
  } else if (tag === 'contact') {
    contactsRef.value?.refresh()
  }
}
</script>
<script lang="ts">
export default {
  name: 'FbuClientsView'
}
</script>
<style lang="scss" scoped></style>
